import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import styles from './ModulePreview.module.scss'
import {setPressHandlers} from '../../../../helpers/utils';

const cx = classnames.bind(styles);

const ModulePreview = function ({className, icon, values, onClick}) {
  const onModuleClick = function (e) {
    e.preventDefault()
    e.stopPropagation()
    onClick && onClick()
  }

  return (
    <label
      className={cx('root', className)}
      {...setPressHandlers(onModuleClick)}
    >
      <i className={cx('icon', `icon-${icon}`)} />
        {values.map((el, i) => (
          <span key={i} className={cx('value-wrap', {empty: !el.value})}>
            <span className={cx('value-label')}>{el.label}</span>
            {!el.readOnly && (
              <input
                value={el.value}
                readOnly={el.readOnly}
                className={cx('value')}
              />
            )}
            {el.readOnly && (
              <span key={i} className={cx('value')}>{el.value}</span>
            )}
          </span>
        ))}
    </label>
  )
}

ModulePreview.propTypes = {
  icon: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    readOnly: PropTypes.bool,
  })),
  onClick: PropTypes.func,
}

export default ModulePreview;
